import { useContext } from 'react';

import { SessionContext } from '../contexts/session.context';

export function useSession() {
    const ctx = useContext(SessionContext);
    return ctx;
}
